import formatCurrency from 'Helper/formatCurrency';

const mappedPromotionProduct = (data) => {
  return data?.promotionProducts?.map((item) => {
    return {
      product: {
        name: item?.name,
        sku: item?.sku,
        brand: item?.brand,
        promoPrice: formatCurrency(item?.promotionPrice),
        discountPercentage: `${item?.discountPercentage}%`,
        normalPrice: formatCurrency(item?.normalPrice),
      },
      remainingStock: item?.remainingStock,
      allocatedStock: item?.allocatedStock,
    };
  });
};
export default mappedPromotionProduct;
